namespace RedBullMOBILE360.Administration {
    export interface UserListRequest extends Serenity.ListRequest {
    }
}
